export default "__VITE_ASSET__b9wFqO_j__"